import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text } from 'components/ui';
import Modal from 'components/Modal/Modal';
import store from 'store/Store';
import Actions from 'actions/Actions';
import resourceWrapper from 'utils/framework/resourceWrapper';
import localeUtils from 'utils/LanguageLocale';
import BiCardModalEN from 'components/GlobalModals/BiCardModal/locales/BiCardModal_en_US';
import BiCardModalFR from 'components/GlobalModals/BiCardModal/locales/BiCardModal_fr_CA';
import BiBarcode from 'components/BiBarcode/BiBarcode';

const { getLocalisedDataFromResource } = localeUtils;
const getText = resourceWrapper(getLocalisedDataFromResource(BiCardModalEN, BiCardModalFR));

function BiCardModal({ isOpen, profileId, onBackBtnClick }) {
    return (
        <Modal
            isOpen={isOpen}
            isDrawer={true}
            onDismiss={() => store.dispatch(Actions.showBiCardModal({ isOpen: false }))}
        >
            <Modal.Header>
                <Modal.Title>{getText('barcodeTitle')}</Modal.Title>
                <Modal.Back onClick={onBackBtnClick} />
            </Modal.Header>
            <Modal.Body>
                <Text
                    is='p'
                    lineHeight='tight'
                    marginBottom={4}
                    children={getText('barcodeDesc')}
                />
                <BiBarcode profileId={profileId} />
            </Modal.Body>
        </Modal>
    );
}

export default wrapFunctionalComponent(BiCardModal, 'BiCardModal');
